package com.yendo.mx.models

import kotlinx.serialization.Serializable

@Serializable
data class DireccionGuardada(
    val id: String = "",
    val titulo: String = "", // Lo usaremos para nombres personalizados si eligen "Otro"
    val direccion: String = "",
    val lat: Double = 0.0,
    val lng: Double = 0.0,
    val cp: String = "",
    val ultimaVezUsada: Long = 0L, // Guarda en qué milisegundo se usó por última vez

    // 🚀 NUEVOS CAMPOS ESTILO UBER EATS / DIDI FOOD
    val tipoUbicacion: String = "Casa", // Puede ser: "Casa", "Trabajo", "Otro"
    val opcionEntrega: String = "Entregar en puerta", // Ej: "Entregar en puerta", "Encontrarse afuera"
    val indicaciones: String = "" // Ej: "Zaguán negro, tocar el timbre 2 veces"
)